import { Stack } from '@mui/material'

import { MetaText } from '@/components/atoms/MetaText'
import type { GuidanceCheckPoint } from '../../types'
import { GuidanceCheckPointCard } from '../GuidanceCheckPointCard'

interface Props {
  points: GuidanceCheckPoint[]
  emptyMessage?: string
  // 指導準備・録音後 view ともに参照のみ (= ・ bullet の細い縦リスト).
  // 済/未 の ephemeral なチェック操作は持たない (= 表示に徹する).
  variant?: 'readonly'
  // false で禁忌 marker を出さない (GuidanceCheckPointCard へそのまま渡す). 既定 true.
  showsContraindication?: boolean
  // true で患者への聞き方を出す (GuidanceCheckPointCard へそのまま渡す). 既定 false.
  showsQuestion?: boolean
}

// V3 確認要点 list. ・ bullet の細い縦リストで参照のみ表示する.
// 各 item は statement + 論拠従属行 の 2 段ゆえ、 item 内 (= 2px) より広い間隔 (= 8px) で
// item 間を区切り、 gestalt で「ひとかたまり」 を視覚化する.
export const GuidanceCheckPointList = ({
  points,
  emptyMessage = '確認要点はまだ生成されていません',
  showsContraindication = true,
  showsQuestion = false,
}: Props) => {
  if (points.length === 0) {
    return <MetaText sx={{ py: 0.5 }}>{emptyMessage}</MetaText>
  }
  return (
    <Stack spacing={1}>
      {points.map((p, idx) => (
        <GuidanceCheckPointCard
          key={idx}
          point={p}
          showsContraindication={showsContraindication}
          showsQuestion={showsQuestion}
        />
      ))}
    </Stack>
  )
}
